import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const BusTable = ({ rows, isLoading }) => {
  const { t } = useLanguage();

  if (isLoading) {
    return (
      <div className="bg-slate-800 rounded-2xl shadow-md border border-slate-700 overflow-hidden">
        <div className="w-full">
          <table className="w-full border-collapse">
            <thead className="bg-slate-900/95">
              <tr>
                <th className="px-4 py-3 text-left text-[10px] uppercase font-bold text-slate-400 border-b border-slate-700">{t('stopName')}</th>
                <th className="px-4 py-3 text-left text-[10px] uppercase font-bold text-slate-400 border-b border-slate-700">{t('eta')}</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <tr key={i} className="border-b border-slate-700">
                  <td className="px-4 py-4">
                    <div className="h-4 bg-slate-700 rounded-md animate-pulse w-3/4" />
                  </td>
                  <td className="px-4 py-4">
                    <div className="h-4 bg-slate-700 rounded-md animate-pulse w-12" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (!rows || rows.length === 0) {
    return (
      <div className="bg-slate-800 rounded-2xl shadow-md border border-slate-700 overflow-hidden">
        <div className="w-full">
          <table className="w-full border-collapse">
            <thead className="bg-slate-900/95">
              <tr>
                <th className="px-4 py-3 text-left text-[10px] uppercase font-bold text-slate-400 border-b border-slate-700">{t('stopName')}</th>
                <th className="px-4 py-3 text-left text-[10px] uppercase font-bold text-slate-400 border-b border-slate-700">{t('eta')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="2" className="px-4 py-16 text-center">
                  <div className="flex flex-col items-center justify-center space-y-3">
                    <div className="p-3 bg-slate-700/50 rounded-full">
                      <SafeIcon icon={FiIcons.FiAlertCircle} className="text-3xl text-slate-500" />
                    </div>
                    <span className="text-slate-400 font-bold tracking-wide uppercase text-sm">
                      {t('outOfService')}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-slate-800 rounded-2xl shadow-md border border-slate-700 overflow-hidden">
      <div className="w-full overflow-x-hidden">
        <table className="w-full border-collapse">
          <thead className="sticky top-0 z-10 bg-slate-900/95 backdrop-blur-sm shadow-sm">
            <tr>
              <th className="px-4 py-3 text-left text-[10px] uppercase tracking-wider font-bold text-slate-400 border-b border-slate-700">
                {t('stopName')}
              </th>
              <th className="px-4 py-3 text-left text-[10px] uppercase tracking-wider font-bold text-slate-400 border-b border-slate-700">
                {t('eta')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-700">
            {rows.map((row, idx) => (
              <motion.tr
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                key={`${idx}-${row.stop_name}`}
                className={`transition-all duration-300 ${row.is_current ? 'bg-blue-600/90 text-white font-bold' : 'hover:bg-slate-700/50 text-slate-200'}`}
              >
                <td className="px-4 py-3.5 text-sm sm:text-base">
                  {row.stop_name}
                </td>
                <td className="px-4 py-3.5 text-sm sm:text-base whitespace-nowrap">
                  {row.eta_time}
                </td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BusTable;